import local from '@/stores/local'
import { useVehicleStore } from '@/stores/vehicle'
import { useAgreementStore } from '@/stores/agreement'
import { useCustomerStore } from '@/stores/customer'

/**
 * Wipes all in-memory store state and the entire IndexedDB cache,
 * then restores only the reCAPTCHA token so the user stays verified.
 * Does NOT navigate — the caller decides where to go next.
 */
export async function resetEverything() {
  const recaptcha = await local.getItem<string>('recaptcha')

  useVehicleStore().reset()
  useAgreementStore().reset()
  useCustomerStore().reset()

  await local.clear()

  if (recaptcha) {
    await local.setItem<string>('recaptcha', recaptcha)
  }
}
